import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsClubhouseComponent } from './simple-icons-clubhouse.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsClubhouseComponent ],
    exports:      [ SimpleIconsClubhouseComponent ],
    bootstrap:    []
})
export class SimpleIconsClubhouseModule {}
